
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 64 64","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"1.414"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M59.999 49.5V53h-56V11h3.5v38.5H60zm-3.5-34.125V27.27c0 .383-.177.652-.533.807-.356.154-.68.086-.97-.205l-3.309-3.308-17.31 17.308a.862.862 0 01-.628.273.864.864 0 01-.629-.273L26.75 35.5 15.373 46.875l-5.25-5.25L26.12 25.628a.866.866 0 01.63-.273.87.87 0 01.628.273L33.749 32l12.688-12.687-3.309-3.308c-.292-.292-.36-.616-.205-.97.155-.356.424-.535.807-.535h11.894c.256 0 .465.083.63.247a.853.853 0 01.245.63z","fill-rule":"nonzero"}})])
          )
        }
      }
    